import { DataGrid } from '@turnpike/portal-data-grid';
import { useSearchParams } from 'react-router-dom';

import { useSystemStatusInfiniteQuery } from '../../api';

import { useSystemStatusTableLayoutColumns } from './SystemStatusTableLayout.columns';
import Styles from './SystemStatusTableLayout.module.scss';

import { useAppSelector } from '@/app/hooks/useAppSelector';

export const SystemStatusTableLayout = () => {
	const [searchParams] = useSearchParams();
	const search = searchParams.get('filter') ?? '';
	const filter = useAppSelector((state) => state.filter);

	const { currentData, isLoading, isFetching } = useSystemStatusInfiniteQuery({
		...filter,
		title: search,
		organizationName: search,
	});

	const isLoadingData = isLoading || (!currentData && isFetching);
	const items = currentData?.pages?.flatMap((page) => page.items) ?? [];
	const { columns, renderDetailsRow } = useSystemStatusTableLayoutColumns();

	return (
		<div className={Styles.container}>
			<div className={Styles.gridContainer}>
				<DataGrid
					isLoading={isLoadingData}
					data={items}
					columns={columns}
					renderExpandedRow={renderDetailsRow}
				/>
			</div>
		</div>
	);
};
